import React from 'react';
import { FiCamera } from 'react-icons/fi';
import ProductSearchInput from './ProductSearchInput';

const PosBarcodeSearchInput = React.forwardRef(({
  value,
  onChange,
  onKeyDown,
  onFocus,
  onBlur,
  onOpenScanner,
  products = [],
  suggestions,
  suggestionLimit,
  suggestionVisibility,
  historyEnabled = true,
  placeholder = 'Nombre o código de barras...',
  ariaLabel,
  inputClassName = 'w-full px-3 py-2.5 text-base md:text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500',
}, ref) => {
  return (
    <ProductSearchInput
      ref={ref}
      type="text"
      placeholder={placeholder}
      aria-label={ariaLabel}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      onBlur={onBlur}
      products={products}
      suggestions={suggestions}
      suggestionLimit={suggestionLimit}
      suggestionVisibility={suggestionVisibility}
      historyEnabled={historyEnabled}
      className={inputClassName}
      containerClassName="relative"
      style={{ paddingRight: '2.75rem' }}
      rightAdornment={(
        <button
          type="button"
          onClick={onOpenScanner}
          className="absolute right-1.5 top-1/2 inline-flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-md text-gray-500 hover:bg-gray-100 hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
          title="Escanear código con cámara"
          aria-label="Escanear código con cámara"
        >
          <FiCamera size={18} />
        </button>
      )}
    />
  );
});

PosBarcodeSearchInput.displayName = 'PosBarcodeSearchInput';

export default PosBarcodeSearchInput;
